// src/utils/arPresentFormI_salim.js
// נטיית הווה-עתיד (מודארע) בבניין 1 לגזרת שלמים

const FATHA = '\u064E';   // َ
const KASRA = '\u0650';   // ِ
const DAMMA = '\u064F';   // ُ
const SUKUN = '\u0652';   // ْ
const SHADDA = '\u0651';  // ّ

// מיפוי אותיות האית"ן לפי כינוי הגוף
const AITHUN_PREFIX = {
  'أَنَا': 'أَ',
  'أَنْتَ': 'تَ',
  'أَنْتِ': 'تَ',
  'هُوَ': 'يَ',
  'هِيَ': 'تَ',
  'نَحْنُ': 'نَ',
  'أَنْتُمْ': 'تَ',
  'أَنْتُنَّ': 'تَ',
  'هُمْ': 'يَ',
  'هُنَّ': 'يَ'
};

// פונקציה לחלץ את שלוש אותיות השורש מהצורה 3ms עבר
function extractRoot(verb3msPast) {
  if (!verb3msPast || verb3msPast.length < 3) return null;
  
  // מסירים ניקוד ומחזירים את 3 האותיות הראשונות
  const clean = verb3msPast.replace(/[\u064B-\u065F]/g, '');
  if (clean.length < 3) return null;
  
  return [clean[0], clean[1], clean[2]];
}

// נורמליזציה של סיווג R2 (a/i/u)
function normalizeR2Class(str) {
  if (!str) return null;
  const s = str.trim().toLowerCase();
  if (s === 'a' || s === 'fatha') return 'a';
  if (s === 'i' || s === 'kasra') return 'i';
  if (s === 'u' || s === 'damma') return 'u';
  return null;
}

// פונקציית הנטייה הראשית
export function conjugatePresentFormI_Salim_fromRow(row) {
  // בודקים שאכן בניין 1 + גזרת שלמים
  const binyan = (row['בניין'] || '').trim();
  const gizra = (row['gizra'] || '').trim();

  if (!(binyan === '1' || binyan === 'בניין 1')) return null;
  if (!gizra.includes('שלמים')) return null;

  const verb3msPast = row['פועל'];
  const root = extractRoot(verb3msPast);
  if (!root) return null;

  const [R1, R2, R3] = root;
  
  // בודקים אם זה פועל נחוס ל' (האות האחרונה של השורש היא ن)
  const isNahusLam = R3 === 'ن';
  
  // קובעים את הניקוד על R2 מה-fa_vowel_future
  const r2Class = normalizeR2Class(row['R2_FUTURE']) || 'a';
  const R2V = r2Class === 'i' ? KASRA : r2Class === 'u' ? DAMMA : FATHA;

  // בונים את הנטיות
  const conjugations = {};

  for (const pronoun of Object.keys(AITHUN_PREFIX)) {
    const prefix = AITHUN_PREFIX[pronoun];
    const stem = prefix + R1 + SUKUN + R2 + R2V + R3;

    if (pronoun === 'أَنْتِ') {
      // R3 + כסרה + ينَ
      conjugations[pronoun] = stem + KASRA + 'ي' + 'نَ';
    } else if (pronoun === 'أَنْتُمْ' || pronoun === 'هُمْ') {
      // R3 + דמה + ونَ
      conjugations[pronoun] = stem + DAMMA + 'و' + 'نَ';
    } else if (pronoun === 'أَنْتُنَّ' || pronoun === 'هُنَّ') {
      // אם האות האחרונה של השורש היא ن: מתרחש אידגום (إدغام)
      // הن של השורש מתמזגת עם הن של הסיומת לن אחת עם שדה
      if (isNahusLam) {
        conjugations[pronoun] = stem + SHADDA + FATHA;
      } else {
        // R3 + סכון + نَ
        conjugations[pronoun] = stem + SUKUN + 'نَ';
      }
    } else {
      // أَنَا, أَنْتَ, هُوَ, هِيَ, نَحْنُ: R3 + דמה
      conjugations[pronoun] = stem + DAMMA;
    }
  }

  return conjugations;
}

// פונקציה עזר לנטייה מפשוטה
export function conjugatePresentFormI_Salim(verb3msPast, r2FutureVowel = 'a') {
  const root = extractRoot(verb3msPast);
  if (!root) return null;

  const row = {
    'פועל': verb3msPast,
    'בניין': '1',
    'זמן': 'עתיד',
    'gizra': 'שלמים',
    'R2_FUTURE': r2FutureVowel
  };

  return conjugatePresentFormI_Salim_fromRow(row);
}
